import { createReducer, on } from '@ngrx/store';
import { GeneralError } from 'vidis-common';
import { DeliveredMedicationItem } from 'vidis-common/delivered-medication';
import {
  DeliveredMedicationsApiActions,
  DeliveredMedicationsStoreActions
} from '../actions/delivered-medication.action';

export interface State {
  items: DeliveredMedicationItem[],
  totalItems: number;
  errors: GeneralError[],
  loading: boolean,
  showDisclaimer: boolean,
  isLoaded: boolean;
}

const initialState: State = {
  items: undefined,
  totalItems: undefined,
  errors: undefined,
  loading: undefined,
  showDisclaimer: true,
  isLoaded: false
};

export const deliveredMedicationReducer = createReducer(
  initialState,
  on(DeliveredMedicationsApiActions.fetchDeliveredMedications, DeliveredMedicationsApiActions.fetchCount, (state): State => ({
    ...state,
    loading: true
  })),
  on(DeliveredMedicationsStoreActions.stopDeliveredMedicationsLoading, (state): State => ({
    ...state,
    loading: false
  })),
  on(DeliveredMedicationsStoreActions.setDeliveredMedications, (state, { listDeliveredMedications }): State => ({
    ...state,
    items: listDeliveredMedications.items || initialState.items,
    errors: listDeliveredMedications.errors || initialState.errors,
    loading: false,
    isLoaded: true
  })),
  on(DeliveredMedicationsStoreActions.setDeliveredMedicationsCount, (state, {countDeliveredMedication}): State => ({
    ...state,
    totalItems: countDeliveredMedication?.count !== undefined ? countDeliveredMedication.count : initialState.totalItems,
    loading: false
  })),
  on(DeliveredMedicationsStoreActions.toggleDeliveredMedicationsDisclaimer, (state): State => ({
    ...state,
    showDisclaimer: !state.showDisclaimer
  })),
  on(DeliveredMedicationsStoreActions.clearDeliveredMedications, () => (initialState)),
);
